export default __webpack_public_path__ + "static/media/hunosa.ffa23adb.png";